// Initial State
export const initialState = {
  companyDetails: {
    companyName: '',
    legalName: '',
    tradingName: '',
    acn: '',
    abn: '',
    address: '',
    website: '',
    phone: '',
    email: ''
  },
  companyOverview: {
    servicesSummary: '',
    companyStructure: ''
  },
  experience: {
    yearsInBusiness: '',
    numberOfStaff: '',
    aeiTraining: false,
    isanaTraining: false,
    maraTraining: false,
    trainingCertificate: null,
    providesVisaAssistance: false,
    providesTravelAssistance: false,
    vetProviders: '',
    higherProviders: '',
    hasFormalAgreements: false,
    formalAgreementsDetails: '',
    hasSubAgents: false,
    subAgentsDetails: '',
    highSchoolStudents: '',
    rtoStudents: '',
    universityStudents: '',
    elicosStudents: '',
    studentFees: '',
    marketingChannels: '',
    popularCourses: '',
    targetCountries: ''
  },
  benefits: {
    benefitsDescription: ''
  },
  referees: [
    {
      companyName: '',
      contactName: '',
      contactPosition: '',
      phone: '',
      email: ''
    },
    {
      companyName: '',
      contactName: '',
      contactPosition: '',
      phone: '',
      email: ''
    }
  ],
  attachments: {
    hasBusinessRegistration: false,
    hasCertificate: false
  },
  declaration: {
    informationTrue: false,
    refereesProvided: false,
    proofAttached: false,
    agreeToTerms: false,
    agreeToPrivacy: false,
    understandResponsibilities: false,
    representativeName: '',
    representativeSignature: '',
    representativePosition: '',
    date: '',
    additionalDocuments: []
  }
};

// Reducer
export function reducer(state, action) {
  switch (action.type) {
    case 'UPDATE_FIELD':
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.value
        }
      };
    case 'UPDATE_REFEREE':
      const newReferees = [...state.referees];
      newReferees[action.index] = {
        ...newReferees[action.index],
        [action.field]: action.value
      };
      return {
        ...state,
        referees: newReferees
      };
    case "SET":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          ...action.payload
        }
      };
    case "SET_FILES":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.files
        }
      };

    case "SET_FILE":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.file
        }
      };
    default:
      return state;
  }
}
 